module.exports = __webpack_public_path__ + "img/instagram.200ccf2a.svg";